export interface SKUStatus {
  code: number;
  label: string;
}

export const SKU_STATUSES = {
  DRAFT: {
    code: 0,
    label: 'Draft',
  },
  REJECTED: {
    code: 1,
    label: 'Rejected',
  },
  UNDER_REVIEW: {
    code: 2,
    label: 'Under Review',
  },
  EFFECTIVE: {
    code: 3,
    label: 'Effective',
  },
  EFFECTIVE_EDITING: {
    code: 4,
    label: 'Effective - Editing',
  },
  EFFECTIVE_REJECTED: {
    code: 5,
    label: 'Effective - Rejected',
  },
} as const;

export const CAN_DELETE_STATUS = [1, 2] as const;

// Only Draft, Rejected, and Effective - Rejected SKUs are eligible for batchAudit submission
export const CAN_SUBMIT_STATUS = [0, 1, 5] as const;

// Only Under Review and Effective - Editing (Under Revision) SKUs are pending an audit decision
export const CAN_APPROVE_STATUS = [2, 4] as const;

export const SKU_STATUS_OPTIONS = [
  {
    label: 'sku_management.status.draft',
    value: '0',
  },
  {
    label: 'sku_management.status.rejected',
    value: '1',
  },
  {
    label: 'sku_management.status.under_review',
    value: '2',
  },
  {
    label: 'sku_management.status.effective',
    value: '3',
  },
  {
    label: 'sku_management.status.effective_editing',
    value: '4',
  },
  {
    label: 'sku_management.status.effective_rejected',
    value: '5',
  },
];

export const getSKUStatusByCode = (code: number): SKUStatus | undefined => {
  return Object.values(SKU_STATUSES).find((status) => status.code === code);
};

export const getSKUStatusByLabel = (label: string): SKUStatus | undefined => {
  return Object.values(SKU_STATUSES).find((status) => status.label === label);
};

export const GOODS_ATTRIBUTE_SOURCES_JSON = {
  SPU: 0, // Product Attributes
  SYS: 1, // System Attributes
  CLASSIFY: 2, // Category Attributes
  ATTACHED: 3, // Additional Attributes
} as const;

export type AttributeSourceType =
  (typeof GOODS_ATTRIBUTE_SOURCES_JSON)[keyof typeof GOODS_ATTRIBUTE_SOURCES_JSON];

export const ATTRIBUTE_SECTION_LABELS = {
  [GOODS_ATTRIBUTE_SOURCES_JSON.SPU]:
    'sku_management.detail.attributes.product_attributes',
  [GOODS_ATTRIBUTE_SOURCES_JSON.SYS]:
    'sku_management.detail.attributes.system_attributes',
  [GOODS_ATTRIBUTE_SOURCES_JSON.CLASSIFY]:
    'sku_management.detail.attributes.category_attributes',
  [GOODS_ATTRIBUTE_SOURCES_JSON.ATTACHED]:
    'sku_management.detail.attributes.additional_attributes',
} as const;
